<ng-container *ngIf="isLoad">
    <div id="editor" [formGroup]="group" class="form-field-margin-bottom">
        <angular-editor
            [config]="editorConfig"
            [formControlName]="field.name"
            [field]="field"
            [group]="group"
            [placeholder]="field.label + (field.required ? ' *' : '')"
        >
        </angular-editor>
        <ng-container
            *ngFor="
                let validation of [
                    {
                        name: 'required',
                        message: appService.language_dictionary.system_field_required,
                    },
                ]
            "
            ngProjectAs="mat-error"
        >
            <mat-error
                *ngIf="group.get(field.name).touched && group.get(field.name).hasError(validation.name)"
                [innerHTML]="
                    validation.name === 'serverError' ? group.get(field.name).errors?.serverError : validation.message
                "
                class="text-xs"
            >
            </mat-error>
        </ng-container>
    </div>
</ng-container>
